import React, { useState, useEffect } from 'react'
import Autocomplete from '@mui/material/Autocomplete'
import TextField from '@mui/material/TextField'
import { getCityList } from '../../../../redux/slices/hotel'
import { useSelector, useDispatch } from 'react-redux'
import {
  Avatar,
  Box,
  List,
  ListItem,
  ListItemAvatar,
  ListItemText,
  ListSubheader
} from '@mui/material'
import PublicIcon from '@mui/icons-material/Public'
import { InputAdornment } from '@mui/material'
import Image from 'next/image'
import { Skeleton } from '@mui/material'

const HotelDestination = ({
  setCityValue,
  cityValue,
  setSearchProduct,
  searchProduct,
  selectedValue,
  setSelectedValue,
  label,
  placeholder,
  setLoading,
  loading,
  autocompleteFirst,
  queryValue = '',
  error,
  helperText
}) => {
  const dispatch = useDispatch();
  const { cityListRes } = useSelector(state => state.hotel)
  const [cityList, setCityList] = useState([])
  const [isOnChange, setIsOnChange] = useState(true)

  useEffect(() => {
    dispatch(getCityList({ search: '' }))
  }, [])

  useEffect(() => {
    if (cityListRes) {
      setCityList(cityListRes.cityList)
    }
  }, [cityListRes])

  const flattenedOptions = cityValue?.reduce((acc, curr) => {
    const values = Array.isArray(curr?.values) ? curr.values : []

    return [
      ...acc,
      ...values.map(value => ({
        group: curr?.label,
        img: curr?.img,
        ...value
      }))
    ]
  }, [])

  const handlePaste = event => {
    event.preventDefault() // Prevent default paste behavior
  }

  function matchCity(val) {
    const result = flattenedOptions?.filter((item) => item?.name === val)
    return result[0]
  }

  useEffect(() => {
    if (queryValue) {
      setIsOnChange(false)
    } else {
      if (isOnChange && flattenedOptions.length > 0) {
        // setSelectedValue(flattenedOptions[0])
        setSelectedValue(searchProduct ? matchCity(searchProduct) : flattenedOptions[0])
        setIsOnChange(false)
      }
    }
  }, [flattenedOptions, isOnChange, searchProduct])

  return (
    <Box className={`searchMenu-loc lg:px-0 js-form-dd`}
      sx={{
        '& label.Mui-focused': {
          color: 'black'
        },

        '& .MuiListSubheader-root': {
          // height: "16px",
          backgroundColor: 'red'
        },
        '& .MuiInputBase-input': {
          // height: "16px",
        },
        '& .MuiAutocomplete-clearIndicator': {
          display: 'none' // Hides the clear (close) button
        },

        '& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline': {
          border: '1px solid rgba(0, 0, 0, 0.5)'
        },
        '& .MuiInput-underline:after': {
          border: '1px solid rgba(0, 0, 0, 0.5)'
        },
        '& .MuiAutocomplete-listbox': {
          overflow: 'hidden'
        },
        '& .MuiOutlinedInput-root': {
          '& fieldset': {
            border: '1px solid rgba(0, 0, 0, 0.5)',
            borderRadius: '8px'
          },
          '&:hover fieldset': {
            border: '1px solid rgba(0, 0, 0, 0.5)'
          },
          '&.Mui-focused fieldset': {
            border: '1px solid rgba(0, 0, 0, 0.5)'
          }
        },
        '&::-webkit-scrollbar': {
          width: '2px'
        },
        '&::-webkit-scrollbar-thumb': {
          backgroundColor: '#888',
          borderRadius: '6px'
        },
        '&::-webkit-scrollbar-thumb:hover': {
          backgroundColor: '#555'
        }
      }}>
      <Autocomplete
        size='small'
        value={selectedValue}
        onChange={(event, newValue) => {
          setSelectedValue(newValue) // Update the selected value in state
          setIsOnChange(false)
        }}
        onInputChange={(event, newInputValue) => {
          setSearchProduct(newInputValue)
          setIsOnChange(false)
        }}
        ref={autocompleteFirst}
        // loading={loading}
        // noOptionsText={`No results found for ${searchProduct}`}
        options={flattenedOptions}
        noOptionsText={
          loading || isOnChange ? (
            <Skeleton variant='text' sx={{ fontSize: '1rem' }} />
          ) : (
            <div
              style={{
                padding: '16px',
                textAlign: 'center',
                color: '#666',
                fontSize: '14px',
                backgroundColor: '#f8f9fa',
                borderRadius: '8px'
              }}
            >
              <strong style={{ fontSize: '16px', color: '#333' }}>
                No results found for {searchProduct}
              </strong>
              <p style={{ marginTop: '5px' }}>
                Try searching with a different keyword.
              </p>
            </div>
          )
        }
        groupBy={option => option.group}
        getOptionLabel={option => option.name} // Display name as the label in the input
        filterOptions={(options, { inputValue }) => {
          const normalizedInput = inputValue.toLowerCase().replace(/\s/g, '');

          return options.filter(option => {
            const name = option.name?.toLowerCase().replace(/\s/g, '');
            const countryName = option.countryName?.toLowerCase().replace(/\s/g, '');
            const countryCode = option.countryCode?.toLowerCase().replace(/\s/g, '');

            return (
              name?.includes(normalizedInput) ||
              countryName?.includes(normalizedInput) ||
              countryCode?.includes(normalizedInput)
            );
          });
        }}

        renderInput={params => (
          <TextField
            {...params}
            label={label}
            placeholder={placeholder}
            InputProps={{
              ...params.InputProps,
              startAdornment: (
                <InputAdornment position='start'>
                  <PublicIcon />
                </InputAdornment>
              ),
              style: error ? { borderColor: 'red' } : {},
              onPaste: handlePaste
            }}
            error={error}
            helperText={helperText}
          />
        )}
        renderOption={(props, option) => (
          <ListItem {...props}>
            <div
              style={{
                minWidth: '35px',
                textAlign: 'left'
              }}
            >
              <Image
                height='100'
                width='100'
                style={{
                  width: '20px',
                  height: '20px'
                }}
                alt={option.name}
                src={option.img}
              />
            </div>
            <ListItemText
              sx={{
                fontSize: '12px'
              }}
              primary={option.name}
              secondary={option.name == option.cityName ? '' : option.cityName}
            />
          </ListItem>
        )}
      />
    </Box>
  )
}

export default HotelDestination
